import { useContext } from 'react';

import { SnrwbCoreContext } from '../snrwbCore';

export const useSnrwbCore = () => useContext(SnrwbCoreContext);
